import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { usePrefs } from "../lib/prefs";
import { Moon, Sun, Type } from "lucide-react";

export default function TopBar() {
  const { user, logout } = useAuth();
  const { prefs, update } = usePrefs();
  return (
    <header
      className="w-full border-b sticky top-0 z-30"
      style={{ borderColor: "var(--gold-soft)", background: "var(--cream)" }}
      data-testid="top-bar"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between px-5 py-4 gap-4">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2 shrink-0">
          <span className="font-serif text-xl tracking-wide" style={{ color: "var(--ink)" }}>
            showgirl desire
          </span>
        </Link>
        <nav className="flex items-center gap-3 text-sm flex-wrap justify-end" style={{ color: "var(--ink-soft)" }}>
          {user && (
            <>
              <button
                onClick={() => update({ font_size: prefs.font_size === "large" ? "normal" : "large" })}
                title={prefs.font_size === "large" ? "normal text size" : "larger text"}
                data-testid="toggle-font-size"
                className="p-1.5"
                style={{ opacity: prefs.font_size === "large" ? 1 : 0.55 }}
              >
                <Type size={16} strokeWidth={1.5} />
              </button>
              <button
                onClick={() => update({ dark_mode: !prefs.dark_mode })}
                title={prefs.dark_mode ? "light mode" : "dark mode"}
                data-testid="toggle-dark-mode"
                className="p-1.5"
              >
                {prefs.dark_mode ? <Sun size={16} strokeWidth={1.5} /> : <Moon size={16} strokeWidth={1.5} />}
              </button>
            </>
          )}
          {user ? (
            <>
              <Link to="/continue" data-testid="nav-continue" className="hover:underline">continue</Link>
              <Link to="/course" data-testid="nav-course" className="hover:underline">all lessons</Link>
              {user.is_admin && (
                <Link to="/admin" data-testid="nav-admin" className="hover:underline">admin</Link>
              )}
              <button onClick={logout} data-testid="nav-logout" className="btn-ghost">sign out</button>
            </>
          ) : (
            <Link to="/login" data-testid="nav-login" className="hover:underline">sign in</Link>
          )}
        </nav>
      </div>
    </header>
  );
}
